(function () {
    'use strict';

    // Variables globales pour les textes localisés
    let langExpand = 'Afficher'; // Fallback par défaut
    let langCollapse = 'Masquer'; // Fallback par défaut

    // Initialisation au chargement du DOM
    document.addEventListener('DOMContentLoaded', function () {
        loadLanguageResources();
        initCategoryToggle();
    });

    /**
     * Charge les ressources de langue depuis les attributs data
     */
    function loadLanguageResources() {
        const container = document.querySelector('.legal-info-page-container');
        if (container) {
            langExpand = container.getAttribute('data-lang-expand') || langExpand;
            langCollapse = container.getAttribute('data-lang-collapse') || langCollapse;
        }
    }

    /**
     * Initialise les événements de clic sur les headers de catégories
     */
    function initCategoryToggle() {
        const categoryHeaders = document.querySelectorAll('.category-header');
        categoryHeaders.forEach(function (header) {
            header.addEventListener('click', function () {
                toggleCategory(this);
            });
        });
    }

    /**
     * Bascule l'état ouvert/fermé d'une catégorie
     * @param {HTMLElement} headerElement - L'élément header cliqué
     */
    function toggleCategory(headerElement) {
        const categoryItem = headerElement.closest('.legal-category');
        const isExpanded = categoryItem.classList.contains('expanded');
        const toggleHint = headerElement.querySelector('.category-toggle-hint');

        if (isExpanded) {
            collapseCategory(categoryItem, toggleHint);
        } else {
            expandCategory(categoryItem, toggleHint);
        }
    }

    /**
     * Déploie une catégorie
     * @param {HTMLElement} categoryItem - L'élément catégorie
     * @param {HTMLElement} toggleHint - Le texte indicateur
     */
    function expandCategory(categoryItem, toggleHint) {
        categoryItem.classList.add('expanded');
        if (toggleHint) {
            toggleHint.textContent = langCollapse; // Utilise la ressource localisée
        }

        // Attendre la fin de l'animation avant de permettre le scroll
        setTimeout(function () {
            const content = categoryItem.querySelector('.category-content');
            if (content) {
                // Forcer le recalcul de hauteur pour le navigateur
                content.style.overflow = 'visible';
            }
            // Scroll doux uniquement si la catégorie est hors de vue
            scrollToElementIfNeeded(categoryItem);
        }, 350); // Correspond à la durée de l'animation CSS (0.3s + marge)
    }

    /**
     * Replie une catégorie
     * @param {HTMLElement} categoryItem - L'élément catégorie
     * @param {HTMLElement} toggleHint - Le texte indicateur
     */
    function collapseCategory(categoryItem, toggleHint) {
        const content = categoryItem.querySelector('.category-content');
        if (content) {
            // Réinitialiser overflow pour l'animation de fermeture
            content.style.overflow = 'hidden';
        }

        categoryItem.classList.remove('expanded');
        if (toggleHint) {
            toggleHint.textContent = langExpand; // Utilise la ressource localisée
        }
    }

    /**
     * Scroll vers un élément uniquement s'il n'est pas visible
     * @param {HTMLElement} element - L'élément cible
     */
    function scrollToElementIfNeeded(element) {
        const rect = element.getBoundingClientRect();
        const headerOffset = 20; // Marge de sécurité en haut

        // Vérifie si l'élément est complètement visible
        const isVisible = (
            rect.top >= headerOffset &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );

        if (!isVisible) {
            // Utiliser le parent scrollable (page container)
            const scrollContainer = document.querySelector('.legal-info-page-container');
            if (scrollContainer) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const elementTop = rect.top - containerRect.top + scrollContainer.scrollTop;
                scrollContainer.scrollTo({
                    top: elementTop - headerOffset,
                    behavior: 'smooth'
                });
            } else {
                // Fallback si le container n'est pas trouvé
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }
        }
    }

    /**
     * Ouvre une catégorie depuis un hash dans l'URL
     */
    function openCategoryFromHash() {
        const hash = window.location.hash.substring(1);
        if (hash) {
            const categoryItem = document.querySelector(`[data-category="${hash}"]`);
            if (categoryItem) {
                const header = categoryItem.querySelector('.category-header');
                const toggleHint = header ? header.querySelector('.category-toggle-hint') : null;
                expandCategory(categoryItem, toggleHint);
            }
        }
    }

    // Ouvrir la catégorie depuis le hash au chargement de la page
    window.addEventListener('load', openCategoryFromHash);

    // Gérer les changements de hash pendant la navigation
    window.addEventListener('hashchange', openCategoryFromHash);

    document.addEventListener('DOMContentLoaded', function () {
        var backicon = document.querySelector('.ribon-back-icon');
        var backtext = document.querySelector('.ribon-back-text');
        if (backicon) {
            backtext.addEventListener('click', function () {
                window.location.href = '/Login';
            });
            backicon.addEventListener('click', function () {
                window.location.href = '/Login';
            });
        }
    });
})();